import { useTheme } from '@mui/material/styles';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { dashboardQueries } from '../queries/dashboardQueries';
import { ACTIVE_IN_SESSION, getActiveInSession } from '../api/DashboardApi';
import { getPieColors } from 'src/common/components/Graphs/common/Graphs/utils/doughnut';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

type UseActiveInSessionDataProps = {
  accountRef: string;
};

export const useActiveInSessionData = ({ accountRef }: UseActiveInSessionDataProps) => {
  const { palette } = useTheme();
  const { t } = useTranslation();

  const { data } = useSuspenseQuery({
    queryKey: dashboardQueries.activeInSession({ accountRef }),
    queryFn: () => setMinimalPromiseTime(getActiveInSession({ accountRef })),
  });

  const activeInSessionData = useMemo(
    () => ({
      labels: [
        t('dashboard.activeInSessionChart.legend.inSession'),
        t('dashboard.activeInSessionChart.legend.outOfSession'),
      ],
      dataset: {
        data: [
          data.data[ACTIVE_IN_SESSION.IN_SESSION],
          data.data[ACTIVE_IN_SESSION.OUT_OF_SESSION],
        ],
        ...getPieColors([palette.blue, palette.amber]),
      },
    }),
    [t, data],
  );

  return { chartData: activeInSessionData, total: data.total };
};
